import posthog from 'posthog-js';
import { getSABAppInstance_Normal } from './shopify-app-bridge/app';
import { getSessionToken } from '@shopify/app-bridge/utilities';
import { store } from 'src/stores/store';
import apiService from 'src/services/api-service';

const initPosthog = async tenantApp => {
  const app = getSABAppInstance_Normal();
  const token = await getSessionToken(app);

  const response = await decodeToken(token);
  const email = tenantApp?.externalInfo?.email || tenantApp?.optEmail || '';
  const distinctId = response?.sub || email || 'anonymous_user';

  apiService.setUserId(distinctId);
  posthog.identify('boostcommerce_BC_' + distinctId, {
    email
  });
};

const beforeSend = event => {
  if (!event) return null;

  const eventProperties = event.properties || {};
  if (eventProperties.$current_url) {
    eventProperties.$current_url = eventProperties.$current_url?.split('?')[0] || '-';
  }

  event.properties = eventProperties;
  return event;
};

const decodeToken = async token => {
  try {
    const host = process.env.REACT_APP_ADMIN_V3_BASE_URL || 'https://staging.bc-solutions.net';
    const decodeTokenUrl = host + '/boost-pfs-admin/admin/decode-token';
    const currentState = store.getState();
    const { authToken } = currentState.oauth;
    const response = await fetch(`${decodeTokenUrl}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-bc-sf-filter-auth': authToken
      },
      body: JSON.stringify({ token })
    });
    const previewData = await response.json();
    return previewData;
  } catch (error) {
    console.error('Warning decoding token:', { error: error.stack });
    return {};
  }
};

export { initPosthog, beforeSend };
